import type { FormErrors, FormValues } from '@viquard/doc-ui/forms';
import type { ZodTypeAny } from 'zod';

// doc-ui's <Form validate={...}> accepts (values) => FormErrors | Promise<...>.
// Zod's safeParse gives us issues; map issue.path[0] (the field name) → message.
//
// We deliberately surface only the first issue per path — the FormError banner
// and per-field hints stay readable, and 99% of forms have one issue per field.
export function zodValidate(schema: ZodTypeAny): (values: FormValues) => FormErrors {
  return (values) => {
    const result = schema.safeParse(values);
    if (result.success) return {};
    const errors: FormErrors = {};
    for (const issue of result.error.issues) {
      const key = issue.path.length > 0 ? String(issue.path[0]) : '_form';
      errors[key] ??= issue.message;
    }
    return errors;
  };
}
